import { JSX } from 'react'

import { IconProps } from '../../icon'

const FontSize: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M27.6 36.6V15H19.2V11H40V15H31.6V36.6H27.6ZM13.2 36.6V23H8V19H22.4V23H17.2V36.6H13.2Z'
      fill='black'
    />
  </svg>
)

export default FontSize
